import axios from 'axios';
import { getToken } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://app.adsmash.org/api';

export interface AdminUserRecord {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: 'user' | 'admin' | string;
  onboardingStatus?: 'password_pending' | 'completed' | string;
  createdAt: string;
  daysUntilPeriodEnd: number | null;
  subscription: {
    status: string;
    plan: string;
    currentPeriodEnd: string | null;
    cancelAtPeriodEnd: boolean;
  };
}

export interface AdminUsersResponse {
  success: boolean;
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  summary: {
    endingWithinDays: number;
    endingSoonCount: number;
    status: Record<string, number>;
  };
  users: AdminUserRecord[];
}

function getAuthHeaders() {
  const token = getToken();
  if (!token) {
    throw new Error('Not authenticated');
  }
  return { Authorization: `Bearer ${token}` };
}

export async function getAdminUsers(params: {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  plan?: string;
  onboardingStatus?: string;
  endingWithinDays?: number;
} = {}): Promise<AdminUsersResponse> {
  const response = await axios.get(`${API_URL}/admin/users`, {
    headers: getAuthHeaders(),
    params,
    timeout: 10000
  });

  return response.data;
}

export async function sendOnboardingReminder(email: string): Promise<{ success: boolean; message: string }> {
  const response = await axios.post(`${API_URL}/auth/send-onboarding-reminder`, { email }, {
    headers: getAuthHeaders(),
    timeout: 10000
  });

  return response.data;
}

export async function purgeNonAdminUsers(options: {
  dryRun?: boolean;
  confirm: string;
}) {
  const response = await axios.post(
    `${API_URL}/admin/users/purge-non-admin`,
    options,
    {
      headers: getAuthHeaders(),
      timeout: 20000
    }
  );
  return response.data;
}

export async function deleteAdminUser(userId: string) {
  const response = await axios.delete(
    `${API_URL}/admin/users/${userId}`,
    {
      headers: getAuthHeaders(),
      timeout: 20000
    }
  );
  return response.data;
}
